import React, { useState } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import ExpandableListItem from 'Components/shared/ExpandableListItem/ExpandableListItem';
import {
	triggerAdditionalSpecAccordionClosedEvent,
	triggerAdditionalSpecAccordionOpenedEvent,
} from 'Services/analytics/events';
import { applyCypressData, capitaliseSentence } from 'Utilities/helpers';

import vehicleFeaturesSectionTexts from '../VehicleFeaturesSection.texts';

import styles from './FeaturesAdditionalSpec.module.scss';

const localT = new MDText(vehicleFeaturesSectionTexts);

const expandableId = 'features-addition-spec';

interface FeaturesAdditionalSpecProps {
	expanded: boolean;
	manuallyAddedAdditionalFeatures: string;
}

export const FeaturesManuallyAddedAdditionalFeatures: React.FC<FeaturesAdditionalSpecProps> = ({
	expanded = false,
	manuallyAddedAdditionalFeatures,
}) => {
	const [isExpanded, setIsExpanded] = useState(expanded);
	const expandableListItemClassNames = {
		container: styles.expandable,
		content: styles.expandableContent,
		header: styles.expandableHeader,
		title: cx(styles.expandableTitle),
	};

	const onExpandableListItemClick = () => {
		if (isExpanded) {
			triggerAdditionalSpecAccordionClosedEvent();
		} else {
			triggerAdditionalSpecAccordionOpenedEvent();
		}

		setIsExpanded(!isExpanded);
	};

	return (
		<div className={styles.container}>
			<ExpandableListItem
				isSmall
				classNames={expandableListItemClassNames}
				id={expandableId}
				isExpanded={isExpanded}
				onClick={onExpandableListItemClick}
				title={`${localT.translate('additionalSpec')}`}
				{...applyCypressData(cypressIds.buttons.accountMenu)}
			>
				<div aria-labelledby={expandableId} className={styles.content} role="region">
					{capitaliseSentence(manuallyAddedAdditionalFeatures)}
				</div>
			</ExpandableListItem>
		</div>
	);
};
